import { render, staticRenderFns } from "./AddAccessHostForm.vue?vue&type=template&id=f8c0fc6e&"
import script from "./AddAccessHostForm.vue?vue&type=script&lang=js&"
export * from "./AddAccessHostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c0fc6e')) {
      api.createRecord('f8c0fc6e', component.options)
    } else {
      api.reload('f8c0fc6e', component.options)
    }
    module.hot.accept("./AddAccessHostForm.vue?vue&type=template&id=f8c0fc6e&", function () {
      api.rerender('f8c0fc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Remote/AddAccessHostForm.vue"
export default component.exports